import { FieldVisitDetail } from "@/pages/ata-rsa-production/field-visit/schema/field-visit.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  detail: FieldVisitDetail | null;
}

export const FieldVisitRequesterObservation = ({ detail }: Props) => {
  return (
    <>
      <Flex alignItems="center" gap="30px">
        <Text fontWeight={700}>Observación del productor</Text>
      </Flex>

      <Flex
        flexDir="column"
        padding="12px"
        height="160px"
        overflowY="auto"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        borderRadius="12px"
        gap="12px"
      >
        <Text fontSize="14px">{detail?.observacionProductor ?? "-"}</Text>
      </Flex>
    </>
  );
};
